module.exports = __webpack_public_path__ + "static/media/eComicScreenPlus-02_2x.5d83c2e8.png";